import { post } from '../query/documents';
import { DocumentsResponseDto } from '../types/documents-response-dto';

interface DispatchAndPrintLabelsParams {
  contentDeclaration: boolean;
  orderIds: string[];
  handleDownload: (file: string) => void;
  generateFile?: boolean;
}

const dispatchAndPrintLabels = async ({
  contentDeclaration,
  orderIds,
  handleDownload,
  generateFile = true
}: DispatchAndPrintLabelsParams): Promise<DocumentsResponseDto> => {
  const response = await post(
    orderIds,
    {
      contentDeclaration
    },
    generateFile
  );
  // DOWNLOAD LABELS
  if (response?.labelsUrls) {
    downloadMultiple(response.labelsUrls, handleDownload);
  }

  // DOWNLOAD CONTENT DECLARATION
  if (contentDeclaration && response?.contentDeclarationsUrls) {
    downloadMultiple(response.contentDeclarationsUrls, handleDownload);
  }

  return response;
};

const downloadMultiple = (
  links: string[],
  handleDownload: (file: string) => void
): void => {
  for (let i = 0; i < links.length; i++) {
    try {
      handleDownload(links[i]);
    } catch (_err) {
      // eslint-disable-next-line no-console
      console.error('handleDownload failed for:', links[i], _err);
    }
  }
};

export default dispatchAndPrintLabels;
